import {parseJobResponse} from "./jobIframeParseVisualizerInfo";
import {setJobEditPopupInfo} from "./jobEditActions";

export const getEditPopupJobResponse = (intl) => {
  return async (dispatch, getState) => {
    const store = getState();
    const {job} = store.jobEditPopupState;
    const jobResponse = await getApiConfig('public/getBvJobData/' + job.id).get();
    const parsedJobData = await parseJobResponse(jobResponse, intl);
    const jobBvJobDataInfo = {
      ...parsedJobData,
      jobTotal: {
        totalWithTaxes: job.grandTotal || job.total // take it from job board response as it is missing in getBvJobData
      }
    }
    console.log("jobBvJobDataInfo", jobBvJobDataInfo);
    dispatch(setJobEditPopupInfo(jobBvJobDataInfo));
    return jobResponse
  }
}
